import { FC } from 'react';
import { FJLogo } from "./FJLogo";



export const Logo: FC = () => {
    return (<>
        <FJLogo />
    </>)
};
